import { createReducer, on } from "@ngrx/store";
import { loadCostsPerEmployeeGroupByIdAct, resetCostsPerEmployeeGroupAct, saveSuccessCostsPerEmployeeGroupAct, setViolationsCostsPerEmployeeGroupAct, showMsgErrorAct, updateSuccessCostsPerEmployeeGroupAct } from "./cost-per-employee-group.action";
import { CostsPerEmployeeGroup } from "../../models/cost-per-employee-group";

const costsPerEmployeeGroup: CostsPerEmployeeGroup = new CostsPerEmployeeGroup();

export const costsPerEmployeeGroupReducer = createReducer (
    {
        costsPerEmployeeGroup,
        violations: {},
        loading: true
    },
    on(resetCostsPerEmployeeGroupAct, (state) => ({
        costsPerEmployeeGroup:  { ...costsPerEmployeeGroup },
        violations: {},
        loading: state.loading
    })),
    on(loadCostsPerEmployeeGroupByIdAct, (state, { costsPerEmployeeGroup }) =>({
        costsPerEmployeeGroup: { ...costsPerEmployeeGroup}, 
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessCostsPerEmployeeGroupAct, (state, { costsPerEmployeeGroupNew }) => ({
        costsPerEmployeeGroup: { ...costsPerEmployeeGroupNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessCostsPerEmployeeGroupAct, (state, { costsPerEmployeeGroupUpdated }) => ({
        costsPerEmployeeGroup: { ...costsPerEmployeeGroupUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsCostsPerEmployeeGroupAct, (state, { costsPerEmployeeGroupForm, violations }) => ({
        costsPerEmployeeGroup: { ...costsPerEmployeeGroupForm },
        violations: {...violations},
        loading: false
    })),
    on(showMsgErrorAct, (state, { error }) => ({
        costsPerEmployeeGroup: state.costsPerEmployeeGroup ,
        violations: {},
        loading: false
    }))
)